<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="Network" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Image Name :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.image_name" @update="updateImageName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Image Path :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-image-upload height="160px" id="image1" menu="network" :model="form.image_path_show"
          @update="updateImagePath" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Url :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.url" @update="updateUrl" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteNetwork" @save-info="saveNetwork" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import { permissionNetwork, role } from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "NetworkEdit",
  components: {
    CommandButton,
    InputImageUpload,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputEditor,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit,
    Loading
  },
  data() {
    return {
      optionBranch: [],
      permission: null,
      isLoading: false
    };
  },
  computed: {
    permissionNetwork,
    ...mapState({
      form: state => {
        return state.Network.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    goToNetworkTable() {
      this.$router.push("/about/network");
    },
    validateSave() {
      if (!this.form.name_th) {
        Swal('', 'Please insert Name TH !', 'error');
        return false;
      } else if (!this.form.name_en) {
        Swal('', 'Please insert Name EN !', 'error');
        return false;
      } else if (!this.form.image_path) {
        Swal('', 'Please insert Image path !', 'error');
        return false;
      } else {
        return true;
      }
    },
    saveClose() {
      this.$store
        .dispatch("Network/saveNetwork", {
          id: this.form.network_id,
          data: this.form
        })
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToNetworkTable();
          }
        })
        .catch(() => {
          Swal('', 'Cannot save network data', 'error');
        });
    },
    saveNetwork() {
      this.isLoading = true;
      this.$store
        .dispatch("Network/saveNetwork", {
          id: this.form.network_id,
          data: this.form
        })
        .then(res => {
          this.isLoading = false;
          Swal(res.response_msg);
        })
        .catch(() => {
          this.isLoading = false;
          Swal('', 'Cannot save network data', 'error');
        });
    },
    deleteNetwork() {
      this.$store
        .dispatch("Network/deleteNetwork", this.form.network_id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToNetworkTable();
          }
        })
        .catch(() => {
          Swal('', 'Cannot delete network data', 'error');
        });
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateImagePath(val) {
      this.form.image_path = val.imagePath;
      this.form.image_path_show = val.fullImagePath;
    },
    updateImageName(val) {
      this.form.image_name = val;
    },
    updateUrl(val) {
      this.form.url = val;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
